/* eslint-disable no-underscore-dangle */
/* eslint-disable no-template-curly-in-string */
import isEmpty from 'lodash/isEmpty'
import * as Yup from 'yup'
import { parsePhoneNumber } from 'react-phone-number-input'

import isValidNpi from './npi'

Yup.setLocale({
  mixed: {
    required: 'Required',
  },
  string: {
    min: 'Must be at least ${min} characters long',
    email: 'Must be a valid e-mail',
  },
})

Yup.addMethod(Yup.string, 'phone', function phoneValidation() {
  return this.test('phone', 'Invalid phone number', value => {
    // Allow nullable/empty values
    // eslint-disable-next-line no-underscore-dangle
    if (this._nullable && !value) return true
    if (!value) return false

    try {
      // Try to parse with 'US' as default country for numbers without +1
      const parsed = parsePhoneNumber(value, 'US')
      return parsed && parsed.isValid()
    } catch (error) {
      return false
    }
  })
})

Yup.addMethod(Yup.string, 'npi', function npiValidation() {
  return this.test('npi', 'Invalid NPI', value => {
    return (this._nullable && !value) || isValidNpi(value)
  })
})

export { Yup }

export function allValuesRequiredCheck(values) {
  const errors = {}
  Object.keys(values).forEach(key => {
    if (!values[key]) errors[key] = 'Required'
  })
  return errors
}

export function loginValidations(values) {
  const errors = allValuesRequiredCheck(values)
  if (isEmpty(errors)) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address'
    }
  }
  return errors
}

export function createYupSchema(schema, config) {
  const { id, validationType, label, validations = [] } = config
  if (!Yup[validationType]) {
    return schema
  }

  let validator = Yup[validationType]()

  validations.forEach(validation => {
    const { params = [], type } = validation
    if (!validator[type]) return

    validator = validator[type](...params)
  })

  validator = validator.label(label)

  schema[id] = validator

  return schema
}
